export function checkInitToken(): () => Promise<boolean> {
  return () => {
    return new Promise((resolve) => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      if (urlSearchParams) {
        const token = urlSearchParams.get('token');
        const refreshToken = urlSearchParams.get('refresh_token');
        const clientEmail = urlSearchParams.get('client_email');
        const salesforceEmail = urlSearchParams.get('salesforce_email')
        if (token && refreshToken && clientEmail && salesforceEmail) {
          localStorage.setItem('access_token', token);
          localStorage.setItem('refresh_token', refreshToken);
          localStorage.setItem('client_email', clientEmail);
          localStorage.setItem('salesforce_email', salesforceEmail);
        }
      }
      resolve(true);
    });
  };
}
